module.exports = __webpack_public_path__ + "static/media/imageUpload.db9df051.svg";